module.exports = new __parcel__URL__("snatchers.ddf075b4.gif").toString();